// extracted by mini-css-extract-plugin
export var active = "_a5-7";
export var container = "_a5-0";
export var evenWidth = "_a5-4";
export var large = "_a5-5";
export var outlet = "_a5-8";
export var slide = "_a5-2";
export var small = "_a5-6";
export var tab = "_a5-3";
export var tabs = "_a5-1";